import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, Typography, TextField, Paper, Avatar, List, ListItem, ListItemAvatar, ListItemText, IconButton, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Document, Packer, Paragraph, TextRun, AlignmentType, HeadingLevel, ImageRun } from "docx";
import bot from '../assets/bot_4712139.png';
import WazeIcon from '@mui/icons-material/Navigation'; // Assuming you have a Waze icon
import PhoneIcon from '@mui/icons-material/Phone';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import SignatureCanvas from 'react-signature-canvas';
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { saveAs } from 'file-saver';
// import gif from '../assets/'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { db } from '../firebase';
import { collection, getDocs, doc, addDoc } from 'firebase/firestore';
import {
  faCircleInfo,
  faAddressBook,
  faRecycle,
  faClock,
  faVideo,
  faMousePointer,
  faArrowCircleLeft,
  faHome,
  faPersonCircleCheck,
  faFileSignature,
  faBarcode,
  faHandHoldingHeart,
  faThumbsUp,
  faBolt,
  faBook
} from '@fortawesome/free-solid-svg-icons';
import html2canvas from 'html2canvas';
import { motion } from 'framer-motion';
import Loading from './Loading';
import { useNavigate } from 'react-router-dom';


const Chat = () => {
  const [messages, setMessages] = useState([
    {
      type: 'text',
      content: [
        'ברוכים הבאים לבוט הלוגיסטי של מדור ציוד דת ולוגיסטיקה ברבנות הצבאית.',
        'אנו עושים כל מאמץ על מנת לתת מענה מיטבי ורלוונטי לכלל חיילי צה"ל.',
        'לנוחיותך ניתן לקבל מגוון פרטים ומידע אודות השירות שהמדור נותן. נא הקש את בחירתך:'
      ], sender: 'bot', options: ['אודות המדור', 'דברו איתנו', 'שעות הפעילות', 'אישור כניסה', 'תיאום והצהרת גניזה', 'המק"טדתון', 'הגשת בקשה לתרומת ציוד דת', 'לוח יד 2 - ציוד הדת הצה״לי', 'דרישות והקצאות בחירום', 'הקטלוג לספרי הקודש הצה"לי', 'הצעות לשיפור אמל"ח ציוד הדת', 'לעמוד ראשי']

    }

    // { text: 'ברוכים הבאים למרכז לוגיסטיקה רבנות צבאית מה ברצונך לעשות?', sender: 'bot', options: ['אודות המדור', 'דרכי תקשורת', 'שעות פעילות', 'תיאום הגעה למרלו"ג ציוד הדת ואישור כניסה', 'נהלי ציוד הדת', 'תיאום והצהרת גניזה'] }
  ]);
  const [userInput, setUserInput] = useState('');
  const [inputDisabled, setInputDisabled] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [formFieldsAA, setFormFieldsAA] = useState({});
  const [isFormValidAA, setIsFormValidAA] = useState(false);
  const [formFieldsG, setFormFieldsG] = useState({});
  const [isFormValidG, setIsFormValidG] = useState(false);
  const [formFieldsB, setFormFieldsB] = useState({});
  const [isFormValidB, setIsFormValidB] = useState(false);
  const [formFieldsSIPAO, setFormFieldsSIPAO] = useState({});
  const [formFieldsSIPA, setFormFieldsSIPA] = useState({});
  const [isFormValidSIPA, setIsFormValidSIPA] = useState(false);
  const [formFieldsS, setFormFieldsS] = useState({});
  const [isFormValidS, setIsFormValidS] = useState(false);
  const [formFieldsSA, setFormFieldsSA] = useState({});
  const [isFormValidSA, setIsFormValidSA] = useState({});
  const [formFieldsSAA, setFormFieldsSAA] = useState({});
  const [isFormValidSAA, setIsFormValidSAA] = useState({});
  const [selectedRegionSS, setSelectedRegionSS] = useState('מרכז'); // ברירת מחדל

  const [formFieldsSS, setFormFieldsSS] = useState({});
  const [isFormValidSS, setIsFormValidSS] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState('');
  const messageEndRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dateSelected, setDateSelected] = useState(false);
  const [items, setItems] = useState([]);
  const [signature, setSignature] = useState('');
  const [ezor, setEzor] = useState('');
  const signaturePadRef = useRef(null);
  const formRef = useRef(null); // Ensure formRef is defined
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [optionfor, setOptionfor] = useState('a');
  const [optionforAA, setOptionforAA] = useState('a');
  const [optionforH, setOptionforH] = useState('');
  const [optionp, setOptionp] = useState('c');
  const hasLinkAMessage = messages.some(m => m.type === 'linkA');
  const [optionpP, setOptionpP] = useState('b');
  const [data, setdata] = useState('');
  const messageRefs = useRef([]);
  const inputRef = useRef(null);

  const handleBlur = () => {
    if (inputRef.current) {
      inputRef.current.blur();
    }
  };


  const handleSignatureEnd = () => {
    const signatureData = signaturePadRef.current.getTrimmedCanvas().toDataURL('image/png');

    setSignature(signatureData);

    const allFieldsFilled = Object.values(formFieldsG).every(field => field !== '') && signatureData;

    setFormFieldsG(prevFields => ({ ...prevFields, ['.חתימה']: signatureData }));
    setFormFieldsG(prevFields => ({ ...prevFields, ['.פיקוד']: optionp }));
    setIsFormValidG(allFieldsFilled);
  };


  useEffect(() => {
    const fetchItems = async () => {
      const itemsCollection = collection(db, 'pdf');
      const itemsSnapshot = await getDocs(itemsCollection);
      const itemsList = itemsSnapshot.docs.map(doc => doc.data());
      setItems(itemsList);
    };

    fetchItems();
  }, []);


  useEffect(() => {
    if (messageRefs.current.length > 0) {
      const lastMessageRef = messageRefs.current[messageRefs.current.length - 1];
      if (lastMessageRef) {
        lastMessageRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [messages]);

  const changeBodyBackground = () => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent); // מזהה iOS

    document.body.style.position = "relative"; // ב-iOS נשתמש ב-'relative' במקום 'fixed'
    document.body.style.background = "linear-gradient(to bottom, #9e9f5d69, rgba(213, 213, 187, 0))";
    document.body.style.backgroundSize = "cover";
    document.body.style.height = "100vh";

    if (!isIOS) {
      document.body.style.backgroundAttachment = "fixed"; // רק באנדרואיד
    } else {
      document.body.style.overflow = "hidden"; // מונע בעיות גלילה
    }
  }

  useEffect(() => {
    changeBodyBackground();
  }, []);


  useEffect(() => {
    // Simulate an async operation, like fetching data
    const timer = setTimeout(() => {
      setLoading(false);
    }, 0); // Adjust the delay as needed

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const allFieldsFilled = Object.values(formFields).every(field => field !== '') && (optionfor !== 'אחר' && optionfor !== 'a') || optionforH !== '';
    setIsFormValid(allFieldsFilled);
  }, [formFields, optionforH, optionfor]);

  useEffect(() => {
    const allFieldsFilled = Object.values(formFieldsAA).every(field => field !== '');
    setIsFormValidAA(allFieldsFilled);
  }, [formFieldsAA]);

  useEffect(() => {
    const allFieldsFilled = Object.values(formFieldsSA).every(field => field !== '');
    setIsFormValidSA(allFieldsFilled);
  }, [formFieldsSA]);

  useEffect(() => {
    const allFieldsFilled = Object.values(formFieldsSAA).every(field => field !== '');
    setIsFormValidSAA(allFieldsFilled);
  }, [formFieldsSAA]);


  useEffect(() => {
    const allFieldsFilled = Object.values(formFieldsG).every(field => field !== '');
    setIsFormValidG(allFieldsFilled);
  }, [formFieldsG]);


  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleGenerateImage = () => {
    html2canvas(formRef.current).then((canvas) => {
      canvas.toBlob((blob) => {
        saveAs(blob, 'form-image.png');
      });
    });
  };

  const openPdf = () => {
    const pdfUrl = items[0].linkA;
    const newWindow = window.open(pdfUrl, '_blank');

    if (newWindow) {
      newWindow.focus();
    } else {
      alert("Please allow popups for this website.");
    }
  };

  const styles = {
    spinnerContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      marginTop: '250px'
    },
  };

  const handleFormFieldChange = (e) => {
    const { id, value } = e.target;
    setFormFields(prevFields => ({ ...prevFields, [id]: value }));
    setFormFields(prevFields => ({ ...prevFields, ['סיבת ביקור']: document.getElementById('sb').value }));
    setFormFields(prevFields => ({ ...prevFields, ['סוג שירות']: document.getElementById('sbAA').value }));
  };

  const handleFormFieldChangeAA = (e) => {
    const { id, value } = e.target;
    setFormFieldsAA(prevFields => ({ ...prevFields, [id]: value }));
    setFormFieldsAA(prevFields => ({ ...prevFields, ['תאריך']: formFieldsAA[selectedDate] }));
  };

  const handleFormFieldChangeB = (e) => {
    const { id, value } = e.target;
    setFormFieldsB(prevFields => ({ ...prevFields, [id]: value }));
    setFormFieldsB(prevFields => ({ ...prevFields, ['פיקוד']: ' ' }));
    const allFieldsFilled = Object.values({ ...formFieldsB, [id]: value }).every(field => field !== '');
    setIsFormValidB(allFieldsFilled);
  };

  const handleFormFieldChangeSIPA = (e) => {
    const { id, value } = e.target;
    setFormFieldsSIPA(prevFields => ({ ...prevFields, [id]: value }));
    const allFieldsFilled = Object.values({ ...formFieldsSIPA, [id]: value }).every(field => field !== '');
    setIsFormValidSIPA(allFieldsFilled);
  };

  const handleFormFieldChangeG = (e) => {
    const { id, value } = e.target;
    setFormFieldsG(prevFields => ({ ...prevFields, [id]: value }));
    const allFieldsFilled = Object.values({ ...formFieldsG, [id]: value }).every(field => field !== '') && signature;
    setIsFormValidG(allFieldsFilled);
  };

  const handleFormFieldChangeS = (e) => {
    const { id, value } = e.target;
    setFormFieldsS(prevFields => ({ ...prevFields, [id]: value }));
    const allFieldsFilled = Object.values({ ...formFieldsS, [id]: value }).every(field => field !== '');
    setIsFormValidS(allFieldsFilled);
  };

  const handleFormFieldChangeSA = (e) => {
    const { id, value } = e.target;
    setFormFieldsSA(prevFields => ({ ...prevFields, [id]: value }));
    const allFieldsFilled = Object.values({ ...formFieldsSA, [id]: value }).every(field => field !== '');
    setIsFormValidSA(allFieldsFilled);
  };

  const handleFormFieldChangeSAA = (e) => {
    const { id, value } = e.target;
    setFormFieldsSAA(prevFields => ({ ...prevFields, [id]: value }));
    const allFieldsFilled = Object.values({ ...formFieldsSAA, [id]: value }).every(field => field !== '');
    setIsFormValidSAA(allFieldsFilled);
  };

  const handleFormFieldChangeSS = (e) => {
    const { id, value } = e.target;
    setFormFieldsSS(prevFields => ({ ...prevFields, [id]: value }));
    const allFieldsFilled = Object.values({ ...formFieldsSS, [id]: value }).every(field => field !== '');
    setIsFormValidSS(allFieldsFilled);
  };

  const handleOptionClick = (option) => {
    if (option === 'המק"טדתון') {
      navigate('/home');
    }
    if (option === 'לעמוד ראשי') {
      navigate('/');
    }
    if (option === 'לוח יד 2 - ציוד הדת הצה״לי') {
      navigate('/giv');
    }
    if (option === 'אישור') {
      sendW();
    }
    if (option === 'להורדת הקובץ') {
      data === 'M' ? handleSubmitFormToAASend() : handleSubmitBSend();
    }


    addUserMessage(option);
  };

  const textSize = (option) => {
    let size = '18px';
    if (option === 'לתיאום במרכז לציוד הדת במחנה שורה' || option === 'לתיאום במפקדת פיקוד הצפון בצפת') {
      size = '15px';
    }
    return size
  }

  const addUserMessage = (text) => {
    const newMessages = [...messages, { text, sender: 'user' }];
    setMessages(newMessages);
    setUserInput('');
    setInputDisabled(true);
    addBotResponse(text);
  };

  const addBotResponse = (input) => {
    const botResponse = getBotResponse(input);
    setMessages((prev) => [...prev, { ...botResponse, sender: 'bot' }]);

    if (botResponse.type === 'form') {
      const initialFormFields = {};
      botResponse.fields.forEach(field => {
        initialFormFields[field] = '';
      });
      setFormFields(initialFormFields);
      setIsFormValid(false); // Ensure the form is initially invalid
    }

    if (botResponse.type === 'formG') {
      const initialFormFieldsG = {};
      botResponse.fields.forEach(field => {
        initialFormFieldsG[field] = '';
      });

      setFormFieldsG(initialFormFieldsG);
      setIsFormValidG(false); // Ensure the form is initially invalid
    }

    if (botResponse.type === 'formSA') {
      const initialFormFieldsG = {};
      botResponse.fields.forEach(field => {
        initialFormFieldsG[field] = '';
      });

      setFormFieldsSA(initialFormFieldsG);
      setIsFormValidSA(false); // Ensure the form is initially invalid
    }

    if (botResponse.type === 'formSAA') {
      const initialFormFieldsG = {};
      botResponse.fields.forEach(field => {
        initialFormFieldsG[field] = '';
      });

      setFormFieldsSAA(initialFormFieldsG);
      setIsFormValidSAA(false); // Ensure the form is initially invalid
    }


    if (botResponse.type === 'formAA') {
      const initialFormFieldsG = {};
      botResponse.fields.forEach(field => {
        initialFormFieldsG[field] = '';
      });

      setFormFieldsAA(initialFormFieldsG);
      setIsFormValidAA(false); // Ensure the form is initially invalid
    }

    if (botResponse.type === 'formB') {
      const initialFormFieldsB = {};
      botResponse.fields.forEach(field => {
        initialFormFieldsB[field] = '';
      });

      setFormFieldsB(initialFormFieldsB);
      setIsFormValidB(false); // Ensure the form is initially invalid
    }


    if (botResponse.type === 'formSIPA') {
      const initialFormFieldsB = {};
      botResponse.fields.forEach(field => {
        initialFormFieldsB[field] = '';
      });

      setFormFieldsSIPA(initialFormFieldsB);
      setIsFormValidSIPA(false); // Ensure the form is initially invalid
    }

    if (botResponse.type === 'formS') {
      const initialFormFieldsS = {};
      botResponse.fields.forEach(field => {
        initialFormFieldsS[field] = '';
      });

      setFormFieldsS(initialFormFieldsS);
      setIsFormValidS(false); // Ensure the form is initially invalid
    }

    if (botResponse.type === 'formSS') {
      const initialFormFieldsSS = {};
      botResponse.fields.forEach(field => {
        initialFormFieldsSS[field] = '';
      });

      setFormFieldsSS(initialFormFieldsSS);
      setIsFormValidSS(false); // Ensure the form is initially invalid
    }
  };

  const getMinDate = () => {
    const today = new Date();
    const minDate = new Date(today.setDate(today.getDate() + 3));
    return minDate;
  };

  const getBotResponse = (input) => {
    let response;

    switch (input.toLowerCase()) {
      case 'אודות המדור':
        response = {
          type: 'text', content: [
            'חיל הרבנות הצבאית רוכש ומספק מידי שנה בשנה מגוון ציוד דת לחיילי צבא ההגנה לישראל, וזאת על מנת לאפשר לכל חייל וחיילת לשמור על אורח חייהם, אמונתם ועולמם הרוחני במהלך השירות הצבאי.',
            ' כל הציוד יוצא לדרך מהמרכז הלוגיסטי של חיל הרבנות הצבאית, במפקדת החיל במחנה שורה.',
            'המרכז ערוך לספק את כלל הציוד הנחוץ לחיילי וחיילות צה"ל בשגרה, בחירום ובמלחמה.',
            'בראש ובראשונה - ציוד הדת: ציציות וכיפות, סידורים, חומשים וטליתות לבתי הכנסת, תפילין, מזוזות ומגילות, נרות לשבת ועוד.',
            `בנוסף אנו מספקים את הציוד הנדרש למעגל השנה: שופרות לראש השנה, ארבעת המינים וסוכות לחג הסוכות, נרות וחנוכיות לחנוכה, מגילות אסתר לפורים, ציוד הכשרה מצות והגדות לחג הפסח ועוד ועוד.`,
            `הרבנות הצבאית גם אמונה לרכוש ולספק את ספרי התנ״ך עליהם נשבעים כל חייל וחיילת בטקס ההשבעה, וכמובן גם את הספרים הנדרשים עבור בני דתות שונות בהתאם לדתם ולאמונתם.`,
            `במרכז הלוגיסטי שלנו תמצאו גם פריטים ייחודיים שאותם מפתחת ומייצרת הרבנות הצבאית, כמו למשל ציוד הלכתי-טכנולוגי חדיש וייחודי וציוד עירובין, המאפשרים לכל חייל וחיילת שומרי שבת להמשיך במשימותיהם המבצעיות לצד שמירת השבת כהלכתה.`,
            `גם הספרות התורנית שמפרסמת הרבנות הצבאית - חוברות, ספרים ועלונים, הן בנושאים הלכתיים והן בנושאים הקשורים לחיזוק הרוח, מאוחסנים במרכז הלוגיסטי לציוד הדת.​​`,
            `מהמרכז הלוגיסטי, כל הציוד יוצא ומופץ אל כלל יחידות צה"ל בעורף ובחזית. ​`,
            `אין ספק - המרכז הלוגיסטי של הרבנות הצבאית הוא אתר ייחודי ומרתק בנוף הצה"לי.​`,
            `יחד, שותפים לניצחון במלחמה!`,
            `יחד, משרתים באמונה!`,
          ], options: ['לסרטון התדמית', 'חזור']
        };
        break;

      case 'שעות הפעילות':
        response = {
          type: 'text', content: ['מדור ציוד דת ולוגיסטיקה פועל בימים אלה במתכונת חירום.',
            'המרכז הלוגיסטי לציוד הדת מקבל קהל בימים א׳-ה׳ בין השעות 08:00-00:00.',
            'וביום ו׳ בין השעות 08:00-12:00. ',
            'משרדי רישום ומלאי זמינים עבורכם בין הימים א׳-ה׳ בין השעות 08:00-20:00.',
            'המרכז הלוגיסטי ומשרדי הקבלה ממוקמים במחנה ״שורה״ – כניסה דרך שער דרומי.',
            'בכל הגעה יש לתאם מראש מול מנפ״ר ציוד הדת, וכן להגיש בקשה לאישור כניסה.',
            'שימו לב כי אין לחנות בחניות השמורות במחנה.',
            'לנוחיותכם קישור להכוונה למחנה ״שורה״ באמצעות אפליקציית ה Waze ⬇️',
          ], options: ['נווט לבסיס', 'חזור']
        };
        break;

      case `תיאום והצהרת גניזה`:
        response = {
          type: 'text', content: ['מעוניינים לגנוז ספרי קודש, עלונים, תשמישי קדושה ומצווה שכבר אינם ראויים לשימוש? הגעתם למקום הנכון!',
            'שימו לב נוהל זה לא מתייחס לריהוט בתי כנסת או גניזה חמורה (כגון ספרי תורה).',
            'פריטים שעדיין ראויים לשימוש, וביחידה שלכם אין בהם צורך, יש לבדוק אפשרות לוויסות פנימי בין היחידות בפיקוד שלכם.',
            'יש לשים לב שהגניזה אינה אסמכתא לזיכוי הסימול מפריטים.',
            'לצורך זיכוי פריטים יש לפתוח בהליך של דרישה להחזרת ציוד מול נגד הלוגיסטיקה ביחידה.',
            'באחריות היחידה לתאם מועד ואישור כניסה כשלושה ימי עבודה קודם לכן בשאלון המקוון מטה.',
            'שים לב כי רק גורם רבנותי בעל דרגת כתף רשאי להצהיר. נא הקש את בחירתך:',
          ], options: ['לתיאום במרכז לציוד הדת במחנה שורה', `לתיאום במפקדת פיקוד הצפון בצפת`, 'חזור']
        }; // Replace with your document URL and filename
        break;

      case `לתיאום במרכז לציוד הדת במחנה שורה`:
        setEzor('M');
        response = {
          type: 'date', content: [`מתי תרצה להגיע?`,
          ], options: ['לתיאום במרכז לציוד הדת במחנה שורה', `לתיאום במפקדת פיקוד הצפון בצפת`, 'חזור']
        };
        break;

      case `לתיאום במפקדת פיקוד הצפון בצפת`:
        setEzor('Z');
        response = {
          type: 'date', content: [`מתי תרצה להגיע?`,
          ], options: ['לתיאום במרכז לציוד הדת במחנה שורה', `לתיאום במפקדת פיקוד הצפון בצפת`, "חזור"]
        };
        break;

      case `הצהרה`:
        response = {
          type: 'text', content: [
            `נא הקש את בחירתך `,
          ], options: ['מסירת הגניזה תתבצע על ידי', 'מסירת הגניזה לא תתבצע על ידי', "חזור"]
        };
        break;

      case `אישור`:
        response = {
          type: 'text', content: [
            `תודה רבה`,
            `בקשתך נקלטה במערכת`,
            `נפגש במועד שנקבע`,
            `כאן בשבילך,`,
            `מדור ציוד דת ולוגיסטיקה`,
          ], options: ["חזור"]
        };
        break;

      case `הבהרה חשובה`:
        let tempText = 'למנפ״ר ציוד הדת בהודעת וואטסאפ במס׳ 052-6774482.'
        if (ezor === 'Z') {
          tempText = 'לנגד ההו״ב הפיקודי, אלי פילו בהודעת וואטסאפ במס׳ 052-9277229.'
        }
        response = {
          type: 'text', content: [
            // `שים לב לאחר מילוי השאלון, יש ללחוץ על כפתור ״השליחה״. יפתח קובץ ״Word” עם פרטי ההצהרה אותו $נדרש לשלוח ידנית$`,
            `להמשך התהליך, יש ללחוץ על הכפתור ״הורדת הקובץ״ - ירד למכשירך קובץ ״Word” עם פרטי ההצהרה אותו $נדרש לשלוח ידנית$`,
            `${tempText}`,
            `לאחר שליחת הקובץ, יש לחזור לאתר לטובת סיום התהליך והגשת הבקשה לאישור כניסה.`,
          ], options: ['להורדת הקובץ', "חזור"]
        };
        break;

      case `לשליחת ההודעה`:
        response = {
          type: 'text', content: [
            `יש ללחוץ על כפתור ה״אישור״ לסיום התהליך ושליחת הבקשה לאישור כניסה.`,
          ], options: ['אישור', "חזור"]
        };
        break;

      case 'הצהרת מסירת גניזה':
        response = { type: 'document', content: 'https://docs.google.com/document/d/190Iy1xvfWJ4dBjdlWYoqnd8M3abYaDZB/edit?usp=sharing&ouid=113800805537619485988&rtpof=true&sd=true', fileName: 'להורדה', options: [] };
        break;

      case `אני בעל דרגת כתף`:
        response = {
          type: 'formG', content: ['אני מצהיר, כי תכולת הגניזה, נבדקה',
            'אין בהם כל מסמכים צבאיים, שסיווגם הביטחוני מוגבל או למעלה ממוגבל, פריטי תחמושת, מוצרי דלק ואריזותיהם, חומרים רעילים או כל חומר מסוכן אחר, העלולים לגרום נזק או אסון.',
            'כמו כן אני מצהיר כי אם ימצא חומר מסווג בגניזה תהיה האחריות הבלעדית על מאשר ההצהרה.',
            'נא מלא את טופס ההצהרה המקוון מטה.',
          ], fields: ['.שם מלא', '.מספר אישי', '.טלפון', '.דרגה', '.תפקיד', '.פיקוד', '.יחידה', '.תאריך', '.חתימה'], options: ["חזור"]
        };
        break;

      case `הגשת בקשה לתרומת ציוד דת`:
        response = {
          type: 'text', content: [`תודה רבה על הרצון לתרום ציוד דת עבור חיילי צה״ל!`,
            `נשמח למענה על שאלון קצר מקוון על מנת שנוכל לטפל בפנייתך. `,
            `לטובת הגשת בקשה לאישור תרומה, אנא בחר מה ברצונך לתרום:`
          ], options: ['פריטי סת״ם', '⁠ספרים, חוברות ועלונים', 'פעילויות וימי עיון', 'פריטי דת שונים', "חזור"]
        };
        break;


      case `הצעות לשיפור אמל"ח ציוד הדת`:
        response = {
          type: 'text', content: [`בחר את פעולתך`,

          ], options: [`הצעה לשיפור ציוד דת קיים`, `הצעה לפיתוח ציוד דת חדש`, "חזור"]
        };
        break;

      case `הצעה לשיפור ציוד דת קיים`:
        setFormFieldsSIPAO('K');
        response = {
          type: 'formSIPA', content: [
            `תודה רבה על הרצון לתרום לשיפור. חשוב לנו לשמוע את דעתך כדי שנוכל לשפר ולייעל את ציוד הדת בצה"ל.`,
            'שים לב, חלה חובת מענה על כל השאלות.',
          ], fields: ['שם מלא של מגיש ההצעה', 'טלפון של מגיש ההצעה', 'שם פריט', 'מה לדעתך צריך לשפר בפריט?'], options: ["חזור"]
        };
        break;


      case `הצעה לפיתוח ציוד דת חדש`:
        setFormFieldsSIPAO('N');
        response = {
          type: 'formSIPA', content: [
            `תודה רבה על הרצון לתרום לשיפור. חשוב לנו לשמוע את דעתך כדי שנוכל לשפר ולייעל את ציוד הדת בצה"ל.`,
            'שים לב, חלה חובת מענה על כל השאלות.',
          ], fields: ['שם מלא של מגיש ההצעה', 'טלפון של מגיש ההצעה', 'שם פריט', `סוג הפריט ציוד שגרה / ציוד חרום`, 'תיאור הפריט'], options: ["חזור"]
        };
        break;


      case `פריטי סת״ם`:
        response = {
          type: 'formS', content: [
            'לצורך התחלת תהליך אישור התרומה, אנא מלא את הפרטים הבאים בשאלון המקוון מטה.',
            `'במהלך ה 36 שעות לאחר שליחת הבקשה, תקבל מס׳ אישור בדיקה בהודעה חוזרת`,
            'לאחר מכן, יש לתאם את הבאת התרומה למכון הסת״ם הצה״לי, הממוקם במחנה ״שורה״, לצורך בדיקה הלכתית. יש לתאם מראש את הגעתך במס׳ טלפון מכון הסת״ם 052-9273566‬',
            'במידה והבדיקה ההלכתית תקינה- ניתן לקבל מס׳ אישור תרומה ולהכניס את הפריט לצבא.',
            'במידה והבדיקה ההלכתית איננה תקינה- תקבל דו״ח עם פירוט התקלות שנמצאו. לאחר תיקון התקלות, יש להביא את התרומה למכון הסת״ם לבדיקה חוזרת ולהמשך התהליך.',
            '*במידה ומדובר על תרומת ספר תורה, והיית רוצה לקיים אירוע ביחידה- יש לתאם מול מכון הסת״ם.',
            'שים לב, חלה חובת מענה על כל השאלות.',
          ], fields: ['שם מלא של ממלא הבקשה', 'טלפון של ממלא הבקשה', 'שם מלא של התורם', 'מספר טלפון של התורם', 'מהי התרומה', 'כמות', 'שווי משוער בשקלים', 'האם ישנה העדפה מסוימת למקום שהתרומה תגיע אליה- אם כן, פרט'], options: ["חזור"]
        };
        break;

      case '⁠ספרים, חוברות ועלונים':
        response = {
          type: 'formSA', content: [
            'לצורך התחלת תהליך אישור התרומה, אנא מלא את הפרטים הבאים בשאלון המקוון מטה.',
            `כחלק מהליך אישור התרומה, הספר או החוברת או העלון נדרשים לעבור את שלב אישור התוכן ע״י סגלי הרבנות הצבאית.`,
            `שלב אישור התוכן יערך עד 14 ימי עבודהמרגע הגשת הבקשה.`,
            `במידה והספר או החוברת או העלון מאושר- תקבל בהודעה חוזרת את מס׳ אישור התרומה. `,
            'לאחר מכן, יש להביא את התרומה למרכז הלוגיסטי לציוד הדת , הממוקם במחנה ״שורה״ או לחילופין למיקום שיוגדר ע״י רמ״ד ציוד דת ולוגיסטיקה.',
            'במידה והספר או החוברת או העלון לא מאושר- תקבל בהודעה חוזרת את העדכון.',
            'שים לב, חלה חובת מענה על כל השאלות.',
            'יש לצרף את תוכן הספר/ חוברת בקובץ pdf בהודעת ווצאפ'
          ], fields: ['שם מלא של ממלא הבקשה', 'טלפון של ממלא הבקשה', 'שם מלא של התורם', 'מס` טלפון של התורם', 'שם הספר או החוברת שברצונך לתרום', 'כמות', 'שווי משוער בשקלים', 'האם ישנה העדפה מסוימת למקום שהתרומה תגיע אליה- אם כן, פרט'], options: ["חזור"]
        };
        break;

      case 'פעילויות וימי עיון':
        response = {
          type: 'formSAA', content: [
            'לצורך התחלת תהליך אישור התרומה, אנא מלא את הפרטים הבאים בשאלון המקוון מטה.',
            `כחלק מהליך אישור התרומה, הפעילות/ יום העיון נדרשים לעבור את שלב אישור התוכן ע״י סגלי הרבנות הצבאית. `,
            `שלב אישור התוכן יערך עד 14 ימי עבודה מרגע הגשת הבקשה.`,
            'במידה והפעילות/ יום העיון מאושרים- תקבל בהודעה חוזרת את מס׳ אישור התרומה. ',
            'לאחר מכן, רמ״ד ציוד דת ולוגיסטיקה ישוחח עימך ויחבר אותך לגורם הרלוונטי בחיל הרבנות הצבאית.',
            'במידה והפעילות או יום העיון לא מאושרים- תקבל בהודעה חוזרת את העדכון.',
            'שים לב, חלה חובת מענה על כל השאלות.',
            'יש לצרף את פירוט ומתווה הפעילות/ יום העיון בקובץ pdf בהודעת ווצאפ'

          ], fields: ['שם מלא של ממלא הבקשה', 'טלפון של ממלא הבקשה', 'שם מלא של התורם', 'מס` טלפון של התורם', 'מהי הפעילות שברצונך לתרום', 'כמות', 'שווי משוער בשקלים', 'האם ישנה העדפה מסוימת למקום שהתרומה תגיע אליה- אם כן, פרט'], options: ["חזור"]
        };
        break;


      case `פריטי דת שונים`:
        response = {
          type: 'formSS', content: [
            'לצורך התחלת תהליך אישור התרומה, אנא מלא את הפרטים הבאים בשאלון המקוון מטה.',
            `'במהלך ה 36 שעות לאחר שליחת הבקשה, תקבל מס׳ אישור תרומה בהודעה חוזרת`,
            'לאחר מכן, יש להביא את התרומה למרכז הלוגיסטי לציוד הדת, הממוקם במחנה ״שורה״ או לחילופין למיקום שיוגדר ע״י רמ״ד ציוד דת ולוגיסטיקה. ',
            'שים לב, חלה חובת מענה על כל השאלות.',
          ], fields: ['שם מלא של ממלא הבקשה', 'טלפון של ממלא הבקשה', 'שם התורם', 'מספר טלפון של התורם', 'מה ברצונך לתרום', 'כמות', 'שווי משוער בשקלים', 'האם ישנה העדפה מסוימת למקום שהתרומה תגיע אליה- אם כן, פרט'], options: ["חזור"]
        };
        break;

      case `אישור כניסה`:
        response = {
          type: 'form', content: [
            'לצורך הגשת בקשה לאישור כניסה למרכז הלוגיסטי לציוד הדת, הממוקם במחנה ״שורה״, יש למלא את הפרטים בטופס המקוון מטה.',
            'בקשה לאישור כניסה תשלח לכל הפחות יום לפני ההגעה, וכן נדרש תיאום אל מול מנפ״ר ציוד הדת.',
          ], fields: ['שם מלא', 'מספר אישי', 'דרגה', 'תעודת זהות', 'טלפון', 'מס רכב', 'צבע רכב', 'סוג רכב', 'סוג שירות', 'תאריך', 'סיבת ביקור'], options: ["חזור"]
        };
        break;

      case `מסירת הגניזה תתבצע על ידי`:
        let temp;
        if (ezor === 'M') {
          temp = [
            'לצורך הגשת בקשה לאישור כניסה למרכז הלוגיסטי לציוד הדת, הממוקם במחנה ״שורה״, יש למלא את הפרטים בטופס המקוון מטה.',
            ' וכן נדרש תיאום אל מול מנפ״ר ציוד הדת.',
          ];
        } else {
          temp = [
            'לצורך הגשת בקשה לאישור כניסה למפקדת פיקוד הצפון בצפת, יש למלא את הפרטים בטופס המקוון מטה.',
            ' וכן נדרש לתיאום ההגעה אל מול נגד ההו״ב הפיקודי. '
          ]
        }
        response = {
          type: 'formAA', content: temp, fields: ['שם מלא', 'מספר אישי', 'תעודת זהות', 'טלפון', 'מס רכב', 'צבע רכב', 'סוג רכב', 'סוג שירות'], options: ["חזור"]
        };
        break;


      case `מסירת הגניזה לא תתבצע על ידי`:
        response = {
          type: 'formB', content: [
            'נא למלא ייפוי כוח של מוסר הגניזה',
          ], fields: ['שם מלא', 'מספר אישי', 'טלפון', 'דרגה', 'תפקיד', 'פיקוד', 'יחידה'], options: ['חזור']
        };
        break;


      case 'דברו איתנו':
        response = {
          type: 'phone', content: [
            { name: 'תא לוגיסטיקה בחמ"ל הרב הראשי לצה"ל', number: '0732432142' },
            { name: 'מפקד המדור – רס"ן אברהם כליפה ', number: '972525829335' },
            { name: `רע"ן לוגיסטיקה במיל' – רס"ן אילן אמויאל`, number: '972529216399' },
            { name: `רמ"ד הפעלה במיל' – סרן  אפיק צוברי `, number: '972526878064' },
            { name: `מנפ"ר ציוד הדת -דניאל מחאני`, number: '972587026363' },
            { name: `מפקד המרלו"ג – רס"ר יקיר משה `, number: '972502266110' },
          ], options: ["חזור"]
        };
        break;


      case 'נווט לבסיס':
        response = {
          type: 'location', content: { address: 'בסיס שורה', wazeLink: 'https://ul.waze.com/ul?ll=31.89576813%2C34.85783815&navigate=yes' }, options: ['חזור']
        };
        break;

      case 'דרישות והקצאות בחירום':
        response = {
          type: 'link', content: { address: 'דרישות והקצאות בחירום', wazeLink: 'https://drishop.digital.idf.il/' }, options: ['חזור']
        };
        break;

      case 'הקטלוג לספרי הקודש הצה"לי':
        response = {
          type: 'linkA', content: { address: 'מקט"ופדיה', wazeLink: 'https://makat-77011.firebaseapp.com' }, options: ['חזור']
        };
        break;


      case `סרטונים`:
        response = {
          type: 'text', content: [`מה תרצה לצפות?`
          ], options: ["סרטוני למידה", "סרטוני עשיית המדור", "חזור"]
        };
        break;



      case "סרטוני למידה":
        response = {
          type: 'videoA', content: [{ a: 'אגידת ארבעת המינים', b: 'https://www.youtube.com/embed/WlSOmiXpe3o' }, { a: 'איך מקימים ערכת עירוב', b: 'https://www.youtube.com/embed/zNPuPXUpQtY' }, { a: 'איך בונים סוכה בצורה נכונה', b: 'https://www.youtube.com/embed/GkFy_EVtWJs' }, { a: 'המדריך המלא לתקוע בשופר', b: 'https://www.youtube.com/embed/OVaUGtzErqg' }], options: ["חזור"]
        };
        break;



      case "סרטוני עשיית המדור":
        response = {
          type: 'videoA', content: [{ a: 'הרבנות הצבאית - חנוכה תשפ״ד - במספרים', b: 'https://www.youtube.com/embed/-jA2fVP-o7Y' }, { a: 'הרבנות הצבאית תשפ״ה: חגי תשרי בעזה ובלבנון', b: 'https://www.youtube.com/embed/K1pAkRmyOyc?si=CkNdNve0IdAEBFVd' }, { a: 'בצל המלחמה: ההיערכות הלוגיסטית הגדולה ביותר בצה״ל לחג הסוכות תשפ״ה', b: 'https://www.youtube.com/embed/tyqFjQCV4KU?si=SDz4R8uszEzcC54P' }, { a: 'מדור לוגיסטיקה וציוד דת', b: 'https://www.youtube.com/embed/LTrrj06ZWnQ' }, { a: 'סירטון תדמית', b: 'https://www.youtube.com/embed/YCRjReg05as?si=w1kFLh85Q2iUHVr9' }], options: ["חזור"]
        };
        break;



      case 'לסרטון התדמית':
        response = {
          type: 'video', content: 'https://www.youtube.com/embed/YCRjReg05as?si=w1kFLh85Q2iUHVr9', options: ["חזור"]
        };
        break;

      case 'חזור':
        setMessages((prev) => prev.slice(0, 0)); // Clear all messages except the initial one
        response = {
          type: 'text', content: [
            'ברוכים הבאים לבוט הלוגיסטי של מדור ציוד דת ולוגיסטיקה ברבנות הצבאית.',
            'אנו עושים כל מאמץ על מנת לתת מענה מיטבי ורלוונטי לכלל חיילי צה"ל.',
            'לנוחיותך ניתן לקבל מגוון פרטים ומידע אודות השירות שהמדור נותן. נא הקש את בחירתך:'
          ], options: ['אודות המדור', 'דברו איתנו', 'שעות הפעילות', 'אישור כניסה', 'תיאום והצהרת גניזה', 'המק"טדתון', 'הגשת בקשה לתרומת ציוד דת', 'לוח יד 2 - ציוד הדת הצה״לי', 'דרישות והקצאות בחירום', 'הקטלוג לספרי הקודש הצה"לי', 'הצעות לשיפור אמל"ח ציוד הדת', 'לעמוד ראשי']
        };
        break;



      default:
        response = {
          type: 'text', content: [
            'ברוכים הבאים לבוט הלוגיסטי של מדור ציוד דת ולוגיסטיקה ברבנות הצבאית.',
            'אנו עושים כל מאמץ על מנת לתת מענה מיטבי ורלוונטי לכלל חיילי צה"ל.',
            'לנוחיותך ניתן לקבל מגוון פרטים ומידע אודות השירות שהמדור נותן. נא הקש את בחירתך:'
          ], options: ['אודות המדור', 'דברו איתנו', 'שעות הפעילות', 'אישור כניסה', 'תיאום והצהרת גניזה', 'המק"טדתון', 'הגשת בקשה לתרומת ציוד דת', 'לוח יד 2 - ציוד הדת הצה״לי', 'דרישות והקצאות בחירום', 'הקטלוג לספרי הקודש הצה"לי', 'הצעות לשיפור אמל"ח ציוד הדת', 'לעמוד ראשי']
        };
        break;
    }

    return response;
  };


  const sendW = () => {
    let phone = ezor === 'M' ? '972587026363' : '972529277229';
    if (data === 'S') {
      const formData = messages.find(message => message.type === 'formB').fields.reduce((acc, field) => {
        // field === 'תאריך' ? acc[field] = getFormattedDate(selectedDate) :
        field === 'פיקוד' ? acc[field] = document.getElementById('piki').value :
          acc[field] = document.getElementById(field).value;

        return acc;
      }, {});

      const formDataA = messages.find(message => message.type === 'formG').fields.reduce((acc, field) => {
        field === '.תאריך' ? acc[field] = getFormattedDate(formFieldsG[field]) :
          field === '.חתימה' ? acc[field] = "חתום דגטלית" :
            field === '.פיקוד' ? acc[field] = document.getElementById('pik').value :
              acc[field] = document.getElementById(field).value;
        return acc;
      }, {});
      const message = Object.entries(formData).map(([key, value]) => `${key}: ${value}`).join('\n');

      const messageA = `תאריך הגעה \n ${getFormattedDate(selectedDate)} \n  *סיבת הגעה:* \n גניזה \n` + '*פרטי ייפוי כוח* \n' + message + `\n *פרטי המהציר* \n` + Object.entries(formDataA).map(([key, value]) => `${key}: ${value}`).join('\n');

      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(messageA)}`, '_blank');


    } else if (data === 'M') {

      const formData = messages.find(message => message.type === 'formAA').fields.reduce((acc, field) => {
        field === 'תאריך' ? acc[field] = getFormattedDate(selectedDate) :
          acc[field] = document.getElementById(field).value;
        return acc;
      }, {});

      const formDataA = messages.find(message => message.type === 'formG').fields.reduce((acc, field) => {
        field === '.תאריך' ? acc[field] = getFormattedDate(formFieldsG[field]) :
          field === '.חתימה' ? acc[field] = "חתום דגטלית" :
            field === '.פיקוד' ? acc[field] = document.getElementById('pik').value :
              acc[field] = document.getElementById(field).value;
        return acc;
      }, {});

      const message = Object.entries(formData).map(([key, value]) => `${key}: ${value}`).join('\n');
      const messageA = `*תאריך הגעה* \n ${getFormattedDate(selectedDate)} \n  *סיבת הגעה:* \n גניזה \n` + message;

      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(messageA)}`, '_blank');

    }
  }

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    setDateSelected(true);
  };

  const handleDateSubmit = () => {
    handleOptionClick('אני בעל דרגת כתף')
  };


  const getFormattedDate = (data) => {
    const date = new Date(data);
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const handleSubmitFormToA = () => {
    const formData = messages.find(message => message.type === 'form').fields.reduce((acc, field) => {
      field === 'תאריך' ? acc[field] = getFormattedDate(formFields[field]) :
        field === 'סיבת ביקור' ? acc[field] = document.getElementById('sb').value == 'אחר' ? document.getElementById('sbi').value : document.getElementById('sb').value :
          field === 'סוג שירות' ? acc[field] = document.getElementById('sbAA').value :
            acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    const message = Object.entries(formData).map(([key, value]) => `*${key}* : ${value}`).join('\n');
    window.open(`https://wa.me/972587026363?text=${encodeURIComponent(`*בקשה לאישור כניסה* \n ${message}`)}`, '_blank');
  };


  const handleSubmitFormToAA = async () => {
    setdata('M');
    addUserMessage('הבהרה חשובה');
  };



  const handleSubmitFormToAASend = async () => {

    let phone = ezor === 'M' ? '972587026363' : '972529277229';
    const formData = messages.find(message => message.type === 'formAA').fields.reduce((acc, field) => {
      field === 'תאריך' ? acc[field] = getFormattedDate(selectedDate) :
        acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    const formDataA = messages.find(message => message.type === 'formG').fields.reduce((acc, field) => {
      field === '.תאריך' ? acc[field] = getFormattedDate(formFieldsG[field]) :
        field === '.חתימה' ? acc[field] = "חתום דגטלית" :
          field === '.פיקוד' ? acc[field] = document.getElementById('pik').value :
            acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    const doc = new Document({
      sections: [{
        properties: {},
        children: [

          new Paragraph({
            text: "הצהרת גניזה",
            heading: HeadingLevel.TITLE,
            alignment: AlignmentType.CENTER,
            spacing: { after: 300 },
            thematicBreak: true,
          }),


          new Paragraph({
            text: `
    אני מצהיר, כי תכולת הגניזה, נבדקה ו
    אין בהם כל מסמכים צבאיים, שסיווגם הביטחוני מוגבל או למעלה ממוגבל, פריטי תחמושת, מוצרי דלק ואריזותיהם, חומרים רעילים או כל חומר מסוכן אחר, העלולים לגרום נזק או אסון.
    כמו כן אני מצהיר כי אם ימצא חומר מסווג בגניזה תהיה האחריות הבלעדית על מאשר ההצהרה.`,
            heading: HeadingLevel.HEADING_4,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),
          new Paragraph({
            text: "פרטי ממלא ההצהרה",
            heading: HeadingLevel.HEADING_1,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),
          ...Object.entries(formDataA).map(([key, value]) => (

            new Paragraph({
              text: `${key}: ${value}`,
              heading: HeadingLevel.HEADING_5,
              alignment: AlignmentType.RIGHT,
              spacing: { after: 200 },
            })
          )),


          new Paragraph({
            text: "תאריך הגעה ",
            heading: HeadingLevel.HEADING_2,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),
          new Paragraph({
            text: getFormattedDate(selectedDate),
            heading: HeadingLevel.HEADING_2,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),

          new Paragraph({
            text: "חתימה:",
            heading: HeadingLevel.HEADING_2,
            alignment: AlignmentType.RIGHT,
            spacing: { before: 200 },
          }),
          ...(signature ? [new Paragraph({
            children: [
              new ImageRun({
                data: signature, // signature image data
                transformation: {
                  width: 200,
                  height: 50,
                },
              }),
            ],
            alignment: AlignmentType.RIGHT,
          })] : []),
        ],
      }],
    });


    const blob = await Packer.toBlob(doc);
    saveAs(blob, ` טופס הצהרת גניזה - ע״ש ${formFieldsG['.שם מלא']}.docx`);
    addUserMessage('לשליחת ההודעה');
  };

  const handleSubmitB = async () => {
    setdata('S');
    addUserMessage('הבהרה חשובה');

  };

  const handleSubmitBSend = async () => {
    setdata('S');
    let phone = ezor === 'M' ? '972587026363' : '972529277229';

    const formData = messages.find(message => message.type === 'formB').fields.reduce((acc, field) => {
      // field === 'תאריך' ? acc[field] = getFormattedDate(selectedDate) :
      field === 'פיקוד' ? acc[field] = document.getElementById('piki').value :
        acc[field] = document.getElementById(field).value;

      return acc;
    }, {});

    const formDataA = messages.find(message => message.type === 'formG').fields.reduce((acc, field) => {
      field === '.תאריך' ? acc[field] = getFormattedDate(formFieldsG[field]) :
        field === '.חתימה' ? acc[field] = "חתום דגטלית" :
          field === '.פיקוד' ? acc[field] = document.getElementById('pik').value :
            acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    const doc = new Document({
      sections: [{
        properties: {},
        children: [

          new Paragraph({
            text: "הצהרת גניזה",
            heading: HeadingLevel.TITLE,
            alignment: AlignmentType.CENTER,
            spacing: { after: 300 },
            thematicBreak: true,
          }),


          new Paragraph({
            text: `
      אני מצהיר, כי תכולת הגניזה, נבדקה ו
      אין בהם כל מסמכים צבאיים, שסיווגם הביטחוני מוגבל או למעלה ממוגבל, פריטי תחמושת, מוצרי דלק ואריזותיהם, חומרים רעילים או כל חומר מסוכן אחר, העלולים לגרום נזק או אסון.
      כמו כן אני מצהיר כי אם ימצא חומר מסווג בגניזה תהיה האחריות הבלעדית על מאשר ההצהרה.`,
            heading: HeadingLevel.HEADING_4,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),
          new Paragraph({
            text: "פרטי ממלא ההצהרה",
            heading: HeadingLevel.HEADING_1,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),
          ...Object.entries(formDataA).map(([key, value]) => (

            new Paragraph({
              text: `${key}: ${value}`,
              heading: HeadingLevel.HEADING_5,
              alignment: AlignmentType.RIGHT,
              spacing: { after: 200 },
            })
          )),


          new Paragraph({
            text: "פרטי ייפוי כוח",
            heading: HeadingLevel.HEADING_1,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),
          new Paragraph({
            text: "תאריך הגעה ",
            heading: HeadingLevel.HEADING_2,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),
          new Paragraph({
            text: getFormattedDate(selectedDate),
            heading: HeadingLevel.HEADING_2,
            alignment: AlignmentType.RIGHT,
            spacing: { after: 200 },
          }),
          ...Object.entries(formData).map(([key, value]) => (

            new Paragraph({
              text: `${key}: ${value}`,
              heading: HeadingLevel.HEADING_5,
              alignment: AlignmentType.RIGHT,
              spacing: { after: 200 },
            })
          )),

          new Paragraph({
            text: "חתימה:",
            heading: HeadingLevel.HEADING_2,
            alignment: AlignmentType.RIGHT,
            spacing: { before: 300 },
          }),
          ...(signature ? [new Paragraph({
            children: [
              new ImageRun({
                data: signature, // signature image data
                transformation: {
                  width: 200,
                  height: 100,
                },
              }),
            ],
            alignment: AlignmentType.RIGHT,
          })] : []),
        ],
      }],
    });

    const blob = await Packer.toBlob(doc);
    // saveAs(blob, ` ${formFieldsG['.שם מלא']} טופס הצהרת גניזה חתום ע"ש .docx`);
    saveAs(blob, ` טופס הצהרת גניזה - ע״ש ${formFieldsG['.שם מלא']}.docx`);
    addUserMessage('לשליחת ההודעה');
  };

  const handleSubmitS = () => {
    const formData = messages.find(message => message.type === 'formS').fields.reduce((acc, field) => {
      acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    // מוסיף את האזור מתוך formFieldsS לתוך formData
    formData['אזור נבחר'] = formFieldsS.region;

    const message = Object.entries(formData)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');

    // בחירת טלפון לפי formFieldsS.region
    let phoneNumber = '972543038700'; // ברירת מחדל

    if (formFieldsS.region === 'מרכז') phoneNumber = '972543038700';
    else if (formFieldsS.region === 'צפון') phoneNumber = '972542681052';
    else if (formFieldsS.region === 'דרום') phoneNumber = '972542681027';

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(`*בקשה לתרומה*\n${message}`)}`;
    window.open(url, '_blank');
  };


  const handleSubmitSAA = () => {
    const formData = messages.find(message => message.type === 'formSAA').fields.reduce((acc, field) => {
      acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    // מוסיף את האזור מתוך formFieldsSAA לתוך formData
    formData['אזור נבחר'] = formFieldsSAA.region;

    const message = Object.entries(formData)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');

    // בחירת טלפון לפי formFieldsSAA.region
    let phoneNumber = '972543038700'; // ברירת מחדל

    if (formFieldsSAA.region === 'מרכז') phoneNumber = '972543038700';
    else if (formFieldsSAA.region === 'צפון') phoneNumber = '972542681052';
    else if (formFieldsSAA.region === 'דרום') phoneNumber = '972542681027';

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(`*בקשה לתרומה פעילות ימי עיון*\n${message}`)}`;
    window.open(url, '_blank');
  };



  const regionPhoneNumbers = {
    'צפון': '972542681052',
    'מרכז': '972543038700', // לדוגמה – המספר שכבר היה
    'דרום': '972542681027'
  };



  const handleSubmitSA = () => {
    const formData = messages.find(message => message.type === 'formSA').fields.reduce((acc, field) => {
      acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    const region = formFieldsSA.region || 'מרכז'; // ברירת מחדל
    formData['מרכב'] = region;

    const message = Object.entries(formData)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');

    const phoneNumber = regionPhoneNumbers[region] || regionPhoneNumbers['מרכז']; // ברירת מחדל

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(`*בקשה לתרומה לספרים* \n ${message}`)}`,
      '_blank'
    );
  };



  const handleSubmitSIPA = () => {
    const formData = messages.find(message => message.type === 'formSIPA').fields.reduce((acc, field) => {
      acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    const message = Object.entries(formData).map(([key, value]) => `${key}: ${value}`).join('\n');
    if (formFieldsSIPAO === 'K') {
      window.open(`https://wa.me/972525829335?text=${encodeURIComponent(`*הצעה לשיפור ציוד הדת הקיים* \n ${message}`)}`, '_blank');
    } else if (formFieldsSIPAO === 'N') {
      window.open(`https://wa.me/972525829335?text=${encodeURIComponent(`*הצעה לפיתוח ציוד דת חדש* \n ${message}`)}`, '_blank');
    }
  };

  const regionToPhone = {
    'מרכז': '972543038700',
    'צפון': '972542681052',
    'דרום': '972542681027'
  };



  const handleSubmitSS = () => {
    const formData = messages.find(message => message.type === 'formSS').fields.reduce((acc, field) => {
      acc[field] = document.getElementById(field).value;
      return acc;
    }, {});

    // מוסיף את האזור מתוך formFieldsSS לתוך formData
    formData['אזור נבחר'] = formFieldsSS.region;

    const message = Object.entries(formData)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');

    // בחירת טלפון לפי formFieldsSS.region
    let phoneNumber = '972543038700'; // ברירת מחדל

    if (formFieldsSS.region === 'מרכז') phoneNumber = '972543038700';
    else if (formFieldsSS.region === 'צפון') phoneNumber = '972542681052';
    else if (formFieldsSS.region === 'דרום') phoneNumber = '972542681027';

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(`*בקשה לתרומה*\n${message}`)}`;
    window.open(url, '_blank');
  };




  const setIcon = {
    'דרישות והקצאות בחירום': faThumbsUp,
    'הגשת בקשה לתרומת ציוד דת': faHandHoldingHeart,
    'המק"טדתון': faBarcode,
    'תיאום והצהרת גניזה': faFileSignature,
    'אישור כניסה': faPersonCircleCheck,
    'שעות הפעילות': faClock,
    'לוח יד 2 - ציוד הדת הצה״לי': faRecycle,
    'סרטונים': faVideo,
    'חזור': faArrowCircleLeft,
    'דברו איתנו': faAddressBook,
    'לעמוד ראשי': faHome,
    'הצעות לשיפור אמל"ח ציוד הדת': faBolt,
    'אודות המדור': faCircleInfo,
    'הקטלוג לספרי הקודש הצה"לי': faBook
  };


  const handleSubmitFormToB = async () => {
    const formData = messages.find(message => message.type === 'formG').fields.reduce((acc, field) => {
      field === '.תאריך' ? acc[field] = getFormattedDate(formFieldsG[field]) :
        field === '.חתימה' ? acc[field] = "חתום דגטלית" :
          field === '.פיקוד' ? acc[field] = document.getElementById('pik').value :
            acc[field] = document.getElementById(field).value;
      return acc;
    }, {});


    addUserMessage('הצהרה');
  };

  const processTextWithBold = (text) => {

    if (text === 'הצהרה') {
      return;
    }

    if (text === 'אני בעל דרגת כתף') {
      return;
    }



    const parts = text.split(/(\$.*?\$)/g); // Split the text by words enclosed in $
    return parts.map((part, index) => {
      if (part.startsWith('$') && part.endsWith('$')) {
        return (
          <span key={index} style={{ fontFamily: 'MyCustomFont7' }}>
            {part.slice(1, -1)} {/* Remove the $ signs */}
          </span>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  if (loading) {
    return <Loading />;
  }

  return (

    <div
      id='chatDiv'
      style={{ height: '100%' }}
    >
      <div style={{ display: loading ? 'fixed' : 'none', ...styles.spinnerContainer }}>
        <ClipLoader size={50} color={"#123abc"} />
      </div>

      <Box>
        <div style={{ fontFamily: 'MyCustomFont7', fontSize: '3.5rem', textAlign: 'center', height: '50px' }}>
          הבוט הלוגיסטי
        </div>

        <div style={{ marginRight: '10px', marginTop: '0', marginLeft: '10px', fontFamily: 'MyCustomFont2', fontSize: '2rem', textAlign: 'center', color: '#a1a25d', height: '30px' }}>
          של מדור ציוד דת ולוגיסטיקה
        </div>
        <div style={{ marginRight: '10px', marginTop: '0', marginLeft: '10px', fontFamily: 'MyCustomFont5', fontSize: '1.5rem', textAlign: 'center', color: '#333333' }}>
          כל מה שצריך לדעת- עכשיו בכף ידך !        </div>
      </Box>

      <Box sx={{
        padding: '0', textAlign: 'center', backgroundColor: 'transparent', color: '#000000', 'text_size': {
          fontSize: '1rem !important', // Adjust the size as needed

        },
      }}>
        <Paper
          id="yyyy"
          sx={{
            fontSize: '0.9rem',
            fontFamily: 'MyCustomFont16',
            margin: '0 auto',
            maxWidth: hasLinkAMessage ? '25rem' : '22rem',
            borderRadius: '50px',
            backgroundColor: '#a2a35b66',
            padding: '0',
            overflow: 'auto',
            maxHeight: '520px'
          }}
        >
          <List id="yyy" sx={{ overflow: 'auto', backgroundColor: 'transparent', borderRadius: '10px', padding: '10px', color: '#000000', scrollbarWidth: 'none' }}>
            {messages.map((message, index) => (
              <ListItem key={index} sx={{ fontSize: '0.9rem', fontFamily: 'MyCustomFont16', justifyContent: message.sender === 'bot' ? 'flex-start' : 'flex-end', padding: '10px 0', flexDirection: 'column', alignItems: message.sender === 'bot' ? 'flex-start' : 'flex-end' }}>
                <Paper
                  sx={{
                    padding: '0px 30px',
                    borderRadius: '20px',
                    backgroundColor: message.sender === 'bot' ? '#f6f5d6;' : '#a2a35b',
                    color: message.sender === 'bot' ? '#000000' : '#000000',
                    maxWidth: '95%',
                    marginBottom: '5px',
                    position: 'relative',
                    display: 'inline',
                    fontFamily: 'MyCustomFont16',
                    textAlign: 'right'
                  }}
                >
                  {message.sender === 'bot' && (
                    <img id='botImage' src={bot} alt="bot" />
                  )}

                  {
                    message.type === 'phone' ? (
                      <List>
                        {message.content.map((contact, i) => (
                          <ListItem key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <div className='text_size' variant="body2" style={{ marginRight: '10px', marginLeft: '10px', fontFamily: 'MyCustomFont16', fontSize: '0.8rem', textAlign: 'right' }}>
                                {/* {contact.name}: {contact.number} */}
                                {contact.name}
                                {/* <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}> */}

                                {/* </Box> */}
                              </div>
                              {!contact.number.startsWith('073') && (
                                <>
                                  <IconButton
                                    href={`https://wa.me/${contact.number}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ color: '#4ca331', textAlign: 'right', width: '50px', borderRadius: '50%', '&:hover': { backgroundColor: '#1EBE57' } }}
                                  >
                                    <WhatsAppIcon sx={{ marginLeft: '9px' }} />
                                  </IconButton>
                                  {/* <PhoneIcon sx={{ marginRight: '5px', color: '#555' }} /> */}
                                  {/* <a href={`tel:${contact.number}`} style={{ color: '#555', textDecoration: 'none' }}>{contact.number}</a> */}
                                  <IconButton
                                    href={`tel:${contact.number}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ color: '#4287d1', textAlign: 'right', marginLeft: '1vh', width: '50px', borderRadius: '50%', '&:hover': { backgroundColor: '#1EBE57' } }}
                                  >
                                    <PhoneIcon sx={{ marginLeft: '9px' }} />
                                  </IconButton>
                                </>
                              )}
                              {contact.number.startsWith('073') && (
                                <IconButton
                                  href={`tel:${contact.number}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{ color: '#4287d1', textAlign: 'right', width: '50px', borderRadius: '50%', '&:hover': { backgroundColor: '#1EBE57' } }}
                                >
                                  <PhoneIcon sx={{ marginLeft: '9px' }} />
                                </IconButton>
                              )}
                            </Box>
                          </ListItem>
                        ))}
                      </List>
                    ) : (
                      message.type !== 'document' && message.type !== 'location' && message.type !== 'link' && message.type !== 'video' && message.type !== 'videoA' && message.type !== 'date' && message.type !== 'linkA' && (
                        <div key={index}
                          ref={(el) => (messageRefs.current[index] = el)} className='text_size' style={{ fontFamily: 'MyCustomFont16' }}>
                          {Array.isArray(message.content)
                            ? message.content.map((line, i) => (
                              <div style={{ marginTop: '0.4rem' }} key={i}>
                                {processTextWithBold(line)}
                              </div>
                            ))
                            : processTextWithBold(message.content || message.text)
                          }
                        </div>
                      )
                    )}

                  {message.type === 'video' && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }}>
                      <iframe
                        width="280"
                        height="157"
                        src={message.content}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </Box>
                  )}

                  {message.type === 'videoA' && (
                    <Box sx={{ justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }}>
                      {message.content.map((content, i) => (
                        <>
                          <p style={{ textAlign: 'center' }}>{content.a}</p>
                          <iframe
                            key={`video${i}.a`}
                            width="280"
                            height="157"
                            src={content.b}
                            title="YouTube video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        </>
                      ))}
                    </Box>
                  )}

                  {message.type === 'form' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {message.fields.map((field, i) => (
                        field.trim() === 'תאריך' ? <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="תאריך"
                            value={formFields['תאריך'] || null}
                            onChange={(newValue) => handleFormFieldChange({ target: { id: 'תאריך', value: newValue } })}
                            renderInput={(params) => <TextField {...params} sx={{ backgroundColor: '#ffffff', borderRadius: '5px', marginBottom: '0.5rem', width: '80%' }} />}
                          />
                        </LocalizationProvider> : field.trim() === 'סיבת ביקור' ?
                          <div>
                            <label>סיבת ביקור</label>
                            <select
                              id='sb'
                              value={optionfor}
                              onChange={(e) => setOptionfor(e.target.value)}
                              style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '5px' }}

                            >
                              <option disabled value="a">בחר אפשרות</option>
                              <option value="משיכת ציוד">משיכת ציוד</option>
                              <option value="זיכוי ציוד">זיכוי ציוד</option>
                              <option value="מסירת גניזה">מסירת גניזה</option>
                              <option value="דיון/פגישה">דיון/פגישה</option>
                              <option value="אחר">אחר</option>
                            </select>
                            {optionfor === 'אחר' && (
                              <div>
                                <label>נא לפרט</label>
                                <input
                                  ref={inputRef}
                                  onBlur={handleBlur}
                                  id='sbi'
                                  type="text"
                                  value={optionforH}
                                  variant="outlined"
                                  placeholder="נא לפרט סיבה"
                                  onChange={(e) => setOptionforH(e.target.value)}
                                  style={{ backgroundColor: '#ffffff', borderRadius: '5px', marginBottom: '0.5rem', marginTop: '0.5rem', width: '80%', height: '2rem', border: 'solid 1px #d9d9c2', padding: '1rem' }}
                                />
                              </div>
                            )}
                          </div>
                          : field.trim() === 'סוג שירות' ? <>
                            <label>סוג שירות</label>
                            <select
                              id='sbAA'
                              value={optionforAA}
                              onChange={(e) => setOptionforAA(e.target.value)}
                              style={{ width: '200px', padding: '8px', border: '1px solid #ccc', borderRadius: '5px', marginBottom: '10px' }}
                            >
                              <option disabled value="a">בחר אפשרות</option>
                              <option value="חובה">חובה</option>
                              <option value="קבע">קבע</option>
                              <option value="מילואים">מילואים</option>
                              <option value="אזרח">אזרח</option>
                            </select>
                          </> :
                            <input
                              ref={inputRef}
                              onBlur={handleBlur}
                              key={i}
                              id={field}
                              variant="outlined"
                              placeholder={field}
                              value={formFields[field] || ''}
                              onChange={handleFormFieldChange}
                              style={{ backgroundColor: '#ffffff', borderRadius: '5px', marginBottom: '0.5rem', marginTop: '0.5rem', width: '80%', height: '2rem', border: 'solid 1px #d9d9c2', padding: '1rem' }}
                            />
                      ))}

                      <div className='row'>
                        <Button
                          variant="contained"
                          sx={{ marginTop: '10px', backgroundColor: '#253b6f', color: '#ffffff', marginBottom: '5px', width: '10rem', height: '3rem' }}
                          onClick={handleSubmitFormToA}
                          disabled={!isFormValid}
                        >
                          שליחה למנפ״ר ציוד הדת
                        </Button>
                      </div>
                    </Box>
                  )}

                  {message.type === 'formAA' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {message.fields.map((field, i) => (
                        <input
                          ref={inputRef}
                          onBlur={handleBlur}
                          key={i}
                          id={field}
                          variant="outlined"
                          placeholder={field}
                          value={formFieldsAA[field] || ''}
                          onChange={handleFormFieldChangeAA}
                          style={{ backgroundColor: '#ffffff', borderRadius: '5px', marginBottom: '0.5rem', marginTop: '0.5rem', width: '80%', height: '2rem', border: 'solid 1px #d9d9c2', padding: '1rem' }}
                        />
                      ))}
                      <div className='row'>
                        {ezor === 'M' ? <Button
                          variant="contained"
                          sx={{ marginTop: '10px', backgroundColor: '#253b6f', color: '#ffffff', marginBottom: '5px', width: '10rem', height: '3rem' }}
                          onClick={handleSubmitFormToAA}
                          disabled={!isFormValidAA}
                        >
                          שליחה למנפ״ר ציוד הדת
                        </Button> :
                          <Button
                            variant="contained"
                            sx={{ marginTop: '10px', backgroundColor: '#253b6f', color: '#ffffff', marginBottom: '5px', width: '10rem', height: '3rem' }}
                            onClick={handleSubmitFormToAA}
                            disabled={!isFormValidAA}
                          >
                            שליחה לנגד הו״ב פצ״ן- אלי פילו
                          </Button>}
                      </div>
                    </Box>
                  )}

                  {message.type === 'formB' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {/* <h5>יש לשלוח בקשה למורשה הצהרה , נא מלא את הפרטים של אותו אדם שברצונך לשלוח לו את הבקשה </h5> */}
                      {message.fields.map((field, i) => (
                        field.trim() === 'פיקוד' ?
                          <div>
                            <label>פיקוד</label>
                            <select
                              id='piki'
                              value={optionpP}

                              // onChange={(newValue) => handleFormFieldChangeG({ target: { id: '.פיקוד', value: newValue }})}
                              onChange={(e) => setOptionpP(e.target.value)}
                              style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '5px' }}
                            >
                              <option disabled value="b">בחר אפשרות</option>
                              <option value="צפון">צפון</option>
                              <option value="דרום">דרום</option>
                              <option value="מרכז">מרכז</option>
                              <option value="זרוע יבשה">זרוע יבשה</option>
                              <option value="חיל הים">חיל הים</option>
                              <option value="חיל האוויר">חיל האוויר</option>
                              <option value="פיקוד העורף">פיקוד העורף</option>
                              <option value="אגף טכנולוגיה ולוגיסטיקה">אגף טכנולוגיה ולוגיסטיקה</option>
                              <option value="אגף המודיעין">אגף המודיעין</option>
                              <option value="אגף כוח אדם">אגף כוח אדם</option>
                              <option value="מטכ״ל">מטכ״ל</option>
                              <option value="תקשוב">תקשוב</option>
                            </select>
                          </div> :
                          <input
                            ref={inputRef}
                            onBlur={handleBlur}
                            key={i}
                            id={field}
                            variant="outlined"
                            placeholder={field}
                            value={formFieldsB[field] || ''}
                            onChange={handleFormFieldChangeB}
                            style={{ backgroundColor: '#ffffff', borderRadius: '5px', marginBottom: '0.5rem', marginTop: '0.5rem', width: '80%', height: '2rem', border: 'solid 1px #d9d9c2', padding: '1rem' }}
                          />
                      ))}
                      <div className='row'>
                        <Button
                          variant="contained"
                          sx={{ marginTop: '10px', backgroundColor: '#253b6f', color: '#ffffff', marginBottom: '5px', width: '10rem', height: '3rem' }}
                          onClick={handleSubmitB}
                          disabled={!isFormValidB}
                        >
                          אישור
                        </Button>
                      </div>
                    </Box>
                  )}



                  {message.type === 'formS' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {message.fields.map((field, i) => (
                        <input
                          ref={inputRef}
                          onBlur={handleBlur}
                          key={i}
                          id={field}
                          variant="outlined"
                          placeholder={field}
                          value={formFieldsS[field] || ''}
                          onChange={handleFormFieldChangeS}
                          style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '5px',
                            marginBottom: '0.5rem',
                            marginTop: '0.5rem',
                            width: '80%',
                            height: '2rem',
                            border: 'solid 1px #d9d9c2',
                            padding: '1rem'
                          }}
                        />
                      ))}

                      {/* רדיו - מרכב */}
                      <div style={{ fontWeight: 'bold', marginTop: '1rem' }}>מרחב</div>
                      <div style={{ display: 'flex', gap: '15px', marginTop: '0.5rem', direction: 'rtl' }}>
                        {['מרכז', 'צפון', 'דרום'].map((region) => (
                          <label key={region} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                            <input
                              type="radio"
                              name="region"
                              value={region}
                              checked={formFieldsS.region === region}
                              onChange={(e) =>
                                setFormFieldsS(prev => ({ ...prev, region: e.target.value }))
                              }
                              style={{ marginLeft: '5px' }}
                            />
                            {region}
                          </label>
                        ))}
                      </div>

                      <div className='row'>
                        <Button
                          variant="contained"
                          sx={{
                            marginTop: '10px',
                            backgroundColor: '#253b6f',
                            color: '#ffffff',
                            marginBottom: '5px',
                            width: '10rem',
                            height: '3rem'
                          }}
                          onClick={handleSubmitS}
                          disabled={!isFormValidS}
                        >
                          שליחה לרמ"ד ציוד דת ולוגיסטיקה
                        </Button>
                      </div>
                    </Box>
                  )}




                  {message.type === 'formSA' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {message.fields.map((field, i) => (
                        <input
                          ref={inputRef}
                          onBlur={handleBlur}
                          key={i}
                          id={field}
                          variant="outlined"
                          placeholder={field}
                          value={formFieldsSA[field] || ''}
                          onChange={handleFormFieldChangeSA}
                          style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '5px',
                            marginBottom: '0.5rem',
                            marginTop: '0.5rem',
                            width: '80%',
                            height: '2rem',
                            border: 'solid 1px #d9d9c2',
                            padding: '1rem'
                          }}
                        />
                      ))}

                      {/* אזור רדיו לבחירת מרכב */}
                      <div style={{ marginTop: '1rem', fontSize: '1rem', fontWeight: 'bold' }}>מרכב:</div>
                      <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', marginBottom: '1rem' }}>
                        {['מרכז', 'צפון', 'דרום'].map((region) => (
                          <label key={region} style={{ fontSize: '0.9rem', display: 'flex', alignItems: 'center' }}>
                            <input
                              type="radio"
                              name="region"
                              value={region}
                              checked={formFieldsSA.region === region}
                              onChange={(e) =>
                                setFormFieldsSA((prev) => ({ ...prev, region: e.target.value }))
                              }
                              style={{ marginRight: '5px' }}
                            />
                            {region}
                          </label>
                        ))}
                      </div>

                      {/* כפתור שליחה */}
                      <div className='row'>
                        <Button
                          variant="contained"
                          sx={{
                            marginTop: '10px',
                            backgroundColor: '#253b6f',
                            color: '#ffffff',
                            marginBottom: '5px',
                            width: '10rem',
                            height: '3rem'
                          }}
                          onClick={handleSubmitSA}
                          disabled={!isFormValidSA}
                        >
                          שליחה לרמ"ד ציוד דת ולוגיסטיקה
                        </Button>
                      </div>
                    </Box>
                  )}





                  {message.type === 'formSIPA' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {message.fields.map((field, i) => (
                        <input
                          ref={inputRef}
                          onBlur={handleBlur}
                          key={i}
                          id={field}
                          variant="outlined"
                          placeholder={field}
                          value={formFieldsSIPA[field] || ''}
                          onChange={handleFormFieldChangeSIPA}
                          style={{ backgroundColor: '#ffffff', borderRadius: '5px', marginBottom: '0.5rem', marginTop: '0.5rem', width: '80%', height: '2rem', border: 'solid 1px #d9d9c2', padding: '1rem' }}
                        />
                      ))}
                      <div className='row'>
                        <Button
                          variant="contained"
                          sx={{ marginTop: '10px', backgroundColor: '#253b6f', color: '#ffffff', marginBottom: '5px', width: '10rem', height: '3rem' }}
                          onClick={handleSubmitSIPA}
                          disabled={!isFormValidSIPA}
                        >
                          שליחה לרמ"ד ציוד דת ולוגיסטיקה
                        </Button>
                      </div>
                    </Box>
                  )}



                  {message.type === 'formSAA' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      {message.fields.map((field, i) => (
                        <input
                          ref={inputRef}
                          onBlur={handleBlur}
                          key={i}
                          id={field}
                          variant="outlined"
                          placeholder={field}
                          value={formFieldsSAA[field] || ''}
                          onChange={handleFormFieldChangeSAA}
                          style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '5px',
                            marginBottom: '0.5rem',
                            marginTop: '0.5rem',
                            width: '80%',
                            height: '2rem',
                            border: 'solid 1px #d9d9c2',
                            padding: '1rem'
                          }}
                        />
                      ))}

                      {/* רדיו - מרחב */}
                      <div style={{ fontWeight: 'bold', marginTop: '1rem' }}>מרחב</div>
                      <div style={{ display: 'flex', gap: '15px', marginTop: '0.5rem', direction: 'rtl' }}>
                        {['מרכז', 'צפון', 'דרום'].map((region) => (
                          <label key={region} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                            <input
                              type="radio"
                              name="regionSAA"
                              value={region}
                              checked={formFieldsSAA.region === region}
                              onChange={(e) =>
                                setFormFieldsSAA(prev => ({ ...prev, region: e.target.value }))
                              }
                              style={{ marginLeft: '5px' }}
                            />
                            {region}
                          </label>
                        ))}
                      </div>

                      <div className='row'>
                        <Button
                          variant="contained"
                          sx={{
                            marginTop: '10px',
                            backgroundColor: '#253b6f',
                            color: '#ffffff',
                            marginBottom: '5px',
                            width: '10rem',
                            height: '3rem'
                          }}
                          onClick={handleSubmitSAA}
                          disabled={!isFormValidSAA}
                        >
                          שליחה לרמ"ד ציוד דת ולוגיסטיקה
                        </Button>
                      </div>
                    </Box>
                  )}




                  {message.type === 'formSS' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                      {message.fields.map((field, i) => (
                        <input
                          ref={inputRef}
                          onBlur={handleBlur}
                          key={i}
                          id={field}
                          variant="outlined"
                          placeholder={field}
                          value={formFieldsSS[field] || ''}
                          onChange={handleFormFieldChangeSS}
                          style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '5px',
                            marginBottom: '0.5rem',
                            marginTop: '0.5rem',
                            width: '80%',
                            height: '2rem',
                            border: 'solid 1px #d9d9c2',
                            padding: '1rem'
                          }}
                        />
                      ))}

                      {/* רדיו - מרחב */}
                      <div style={{ fontWeight: 'bold', marginTop: '1rem' }}>מרחב</div>
                      <div style={{ display: 'flex', gap: '15px', marginTop: '0.5rem', direction: 'rtl' }}>
                        {['מרכז', 'צפון', 'דרום'].map((region) => (
                          <label key={region} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                            <input
                              type="radio"
                              name="regionSS"
                              value={region}
                              checked={formFieldsSS.region === region}
                              onChange={(e) =>
                                setFormFieldsSS(prev => ({ ...prev, region: e.target.value }))
                              }
                              style={{ marginLeft: '5px' }}
                            />
                            {region}
                          </label>
                        ))}
                      </div>

                      <div className='row'>
                        <Button
                          variant="contained"
                          sx={{
                            marginTop: '10px',
                            backgroundColor: '#253b6f',
                            color: '#ffffff',
                            marginBottom: '5px',
                            width: '10rem',
                            height: '3rem'
                          }}
                          onClick={handleSubmitSS}
                          disabled={!isFormValidSS}
                        >
                          שליחה לרמ"ד ציוד דת ולוגיסטיקה
                        </Button>
                      </div>
                    </Box>
                  )}







                  {message.type === 'formG' && (
                    <Box id="form-container" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflowX: 'hidden' }}>
                      {message.fields.map((field, i) => (
                        field.trim() === '.תאריך' ? <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="תאריך הצהרה"
                            value={formFieldsG['.תאריך'] || null}
                            onChange={(newValue) => handleFormFieldChangeG({ target: { id: '.תאריך', value: newValue } })}
                            onAccept={(newValue) => handleFormFieldChangeG({ target: { id: '.תאריך', value: newValue } })}
                            renderInput={(params) => <TextField {...params} sx={{ backgroundColor: '#ffffff', borderRadius: '5px', marginBottom: '0.5rem', width: '80%' }} />}
                          />
                        </LocalizationProvider> : field.trim() === '.חתימה' ?
                          <Box sx={{ width: '80%', marginTop: '1rem', border: 'solid 1px', background: '#d3d3b2' }}>
                            <Typography variant="body2">חתימה:</Typography>
                            <SignatureCanvas
                              ref={signaturePadRef}
                              penColor='black'
                              canvasProps={{ width: 300, height: 100, className: 'sigCanvas' }}
                              onEnd={handleSignatureEnd}
                            />
                            <Button onClick={() => signaturePadRef.current.clear()} sx={{ marginTop: '0.5rem' }}>נקה חתימה</Button>
                          </Box>
                          : field.trim() === '.פיקוד' ?
                            <div>
                              <label>פיקוד</label>
                              <select
                                id='pik'
                                value={optionp}
                                // onChange={(newValue) => handleFormFieldChangeG({ target: { id: '.פיקוד', value: newValue }})}
                                onChange={(e) => setOptionp(e.target.value)}
                                style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '5px' }}
                              >
                                <option disabled value="c">בחר אפשרות</option>
                                <option value="צפון">צפון</option>
                                <option value="דרום">דרום</option>
                                <option value="מרכז">מרכז</option>
                                <option value="זרוע יבשה">זרוע יבשה</option>
                                <option value="חיל הים">חיל הים</option>
                                <option value="חיל האוויר">חיל האוויר</option>
                                <option value="פיקוד העורף">פיקוד העורף</option>
                                <option value="אגף טכנולוגיה ולוגיסטיקה">אגף טכנולוגיה ולוגיסטיקה</option>
                                <option value="אגף המודיעין">אגף המודיעין</option>
                                <option value="אגף כוח אדם">אגף כוח אדם</option>
                                <option value="מטכ״ל">מטכ״ל</option>
                                <option value="תקשוב">תקשוב</option>
                              </select>
                            </div>
                            :
                            <input
                              ref={inputRef}
                              onBlur={handleBlur}
                              key={i}
                              id={field}
                              variant="outlined"
                              placeholder={field}
                              value={formFieldsG[field] || ''}
                              onChange={handleFormFieldChangeG}
                              style={{ backgroundColor: '#ffffff', borderRadius: '5px', marginBottom: '0.5rem', marginTop: '0.5rem', width: '80%', height: '2rem', border: 'solid 1px #d9d9c2', padding: '1rem' }}
                            />
                      ))}

                      <div className='row'>
                        {ezor === 'M' ? <Button
                          variant="contained"
                          sx={{ marginTop: '10px', backgroundColor: '#253b6f', color: '#ffffff', marginBottom: '5px', width: '10rem', height: '3rem' }}
                          onClick={handleSubmitFormToB}
                          disabled={!isFormValidG}
                        >
                          לחץ להמשך
                        </Button> :
                          <Button
                            variant="contained"
                            sx={{ marginTop: '10px', backgroundColor: '#253b6f', color: '#ffffff', marginBottom: '5px', width: '10rem', height: '3rem' }}
                            onClick={handleSubmitFormToB}
                            disabled={!isFormValidG}
                          >

                            לחץ להמשך
                          </Button>}
                      </div>
                    </Box>
                  )}


                  {message.type === 'location' && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }}>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ borderRadius: '10px', borderColor: '#cbcba5' }}
                        href={message.content.wazeLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WazeIcon sx={{ marginRight: '5px' }} />
                        פתח בוויז
                      </Button>
                    </Box>
                  )}

                  {message.type === 'link' && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }}>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ borderRadius: '10px', borderColor: '#cbcba5' }}
                        href={message.content.wazeLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        למעבר לאפליקציה
                      </Button>
                    </Box>
                  )}

                  {message.type === 'linkA' && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'start',
                        width: '100%',
                        height: '65vh', // גובה מותאם
                        overflowX: 'auto',
                        padding: '1rem 0',
                      }}
                    >
                      <iframe
                        src={items[0].linkA}
                        title="קטלוג ספרי הקודש"
                        style={{
                          width: '95%',
                          minWidth: '500px', // קובע מינימום שימנע גלילה לרוחב
                          height: '100%',
                          border: 'none',
                          borderRadius: '12px',
                        }}
                      ></iframe>
                    </Box>
                  )}





                  {message.type === 'date' && (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      {/* <p>מתי תרצה להגיע ?</p> */}
                      <DatePicker
                        label="מתי תרצה להגיע?"
                        value={selectedDate || null}
                        onChange={handleDateChange}
                        onAccept={handleDateSubmit}
                        renderInput={(params) => <TextField {...params} />}
                        minDate={getMinDate()}
                      />
                    </LocalizationProvider>
                  )}


                </Paper>
                {index === messages.length - 1 && message.options && (
                  <div
                    style={{
                      padding: '5px',
                      borderRadius: '15px', // פינות מעוגלות למיכל הראשי
                      backgroundColor: 'transparent', // רקע עדין
                      maxWidth: '95%',
                      marginBottom: '5px',
                      position: 'relative',
                      textAlign: 'right',
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // הצללה עדינה
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <div
                      id="yyy"
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)', // רשת של 2 כרטיסים בכל שורה
                        gap: '20px', // רווח בין הכרטיסים
                        width: '100%',
                        maxHeight: '300px', // גובה מקסימלי עם גלילה
                        overflowY: 'auto', // גלילה אנכית
                        padding: '10px', // רווח פנימי בתוך האזור הגלילה
                      }}
                    >
                      {message.options.map((option, i) => (
                        <div
                          key={i}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#333333', // רקע כהה לכרטיסים
                            borderRadius: '15px', // פינות עגולות לכרטיס
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)', // הצללה רכה
                            padding: '20px',
                            height: '120px', // גובה אחיד לכרטיסים
                            cursor: 'pointer',
                            transition: 'transform 0.3s ease', // אפקט מעבר ריחוף
                            color: '#ffffff',
                          }}
                          onClick={() => handleOptionClick(option)}
                        >
                          {/* אייקון */}
                          <FontAwesomeIcon
                            icon={setIcon[option] || faMousePointer}
                            style={{
                              fontSize: '36px',
                              color: '#ffffff', // צבע לבן לאייקון
                              marginBottom: '10px', // רווח מתחת לאייקון
                            }}
                          />

                          {/* טקסט */}
                          <span
                            style={{
                              fontFamily: 'MyCustomFont4',
                              fontSize: textSize(option), // פונקציה לגודל דינמי
                              color: '#ffffff',
                              textAlign: 'center',
                            }}
                          >
                            {option}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              </ListItem>
            ))}
            <div ref={messageEndRef} />
          </List>
        </Paper>
      </Box>
    </div>
  );
};

export default Chat;
